import axios from './config';

const baseURL = '/payments';

// Payment Endpoints
export const paymentAPI = {
  // Initiate M-Pesa STK Push payment (DEPRECATED - use purchaseCourse instead)
  initiatePayment: (amount, msisdn) => 
    axios.post(`${baseURL}/deposit`, { amount, msisdn }),
  
  // Get payment status
  getPaymentStatus: (checkoutRequestId) => 
    axios.get(`${baseURL}/payment-status/${checkoutRequestId}`),
  
  // Get user verification info (MSISDN)
  getUserVerification: () => 
    axios.get('/verify'),
  
  // Get subscription status (DEPRECATED)
  getSubscriptionStatus: () => 
    axios.get(`${baseURL}/subscription-status`),

  // ==================== NEW COURSE PURCHASE ENDPOINTS ====================
  
  // Purchase a course via M-Pesa STK Push
  purchaseCourse: (courseId, amount, msisdn) => 
    axios.post(`${baseURL}/purchase-course`, { 
      course_id: courseId, 
      amount, 
      msisdn 
    }),
  
  // Get all courses purchased by the current user
  getMyCourses: () => 
    axios.get(`${baseURL}/my-courses`),
  
  // Check if current user owns a specific course
  checkCourseOwnership: (courseId) => 
    axios.get(`${baseURL}/check-course-ownership/${courseId}`),
};

export default paymentAPI;
